var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-item",class:_vm.classes,domProps:{"textContent":_vm._s(_vm.number + '/' + _vm.$parent.numberOfPage)},on:{"click":_vm.actionClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }